/**
 * 节流
 * 一定的时间周期内时间内只执行一次函数，执行函数后，进入下一个时间周期计时
 * @param callback    {function}  需要执行的方法
 * @param time        {number}    间隔时间(毫秒)
 * @returns {function(): void}
 */
export function throttle(callback,time = 1000){
  let before = 0;
  if(typeof callback !== "function") return function(){};
  if(typeof time !== "number" || time < 0) time = 1000;
  return function(){
    let now = Date.now();
    if(now === 0 ||  now - time >= before) {
      callback.apply(this,arguments);
      before = now;
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-tools-kit/src/modules/throttle.js
// module id = null
// module chunks = 